import { render, staticRenderFns } from "./connection-indicator.vue?vue&type=template&id=03883d56&scoped=true"
import script from "./connection-indicator.vue?vue&type=script&lang=js"
export * from "./connection-indicator.vue?vue&type=script&lang=js"
import style0 from "./connection-indicator.vue?vue&type=style&index=0&id=03883d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03883d56",
  null
  
)

export default component.exports